var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.613,
    height: 84.192,
    viewBox: "0 0 88.613 84.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 18.174,
    cy: 18.174,
    r: 18.174,
    transform: "translate(0)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(-1016.788 -1721.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cost-per-lead_11336391",
    d: "M51.972,52.914A12.968,12.968,0,1,0,39,39.946,12.983,12.983,0,0,0,51.972,52.914Zm0-23.1A10.131,10.131,0,1,1,41.841,39.946,10.143,10.143,0,0,1,51.972,29.815Zm2.1,13.682a.784.784,0,0,0,.18-.676c-.041-.338-.137-1.129-2.5-1.517-3.792-.623-4.458-2.777-4.517-4.006a4.207,4.207,0,0,1,3.318-4.253v-.408a1.418,1.418,0,0,1,2.837,0v.395a4.8,4.8,0,0,1,3.29,2.856,1.418,1.418,0,1,1-2.616,1.1,2.255,2.255,0,0,0-2.654-1.232c-.327.074-1.391.395-1.342,1.406.013.274.049,1,2.144,1.344,2.959.486,4.592,1.823,4.853,3.974a3.612,3.612,0,0,1-.85,2.874A5.107,5.107,0,0,1,53.391,46.9v.358a1.418,1.418,0,1,1-2.837,0v-.382A4.8,4.8,0,0,1,46.891,43.4a1.418,1.418,0,1,1,2.753-.686A2.293,2.293,0,0,0,52.089,44.2a2.873,2.873,0,0,0,1.98-.706ZM78.415,68.93c-.167,0-.333,0-.5.007V31.724c0-5.348-3.814-11.085-9.493-11.1l-50.747-.158H17.6A9.606,9.606,0,0,0,9.289,34.876a1.418,1.418,0,0,0,1.228.708H26.028V88.308c0,5.281,3.722,10.938,9.283,11.1a1.408,1.408,0,0,0,.21.018l31.207.091A17.525,17.525,0,1,0,78.415,68.93ZM93.108,86.459a14.608,14.608,0,0,1-2.753,8.547,12.635,12.635,0,0,0-7.12-7.464,7.107,7.107,0,1,0-9.638,0,12.635,12.635,0,0,0-7.12,7.464,14.688,14.688,0,1,1,26.632-8.547ZM74.146,82.325a4.27,4.27,0,1,1,4.27,4.27A4.275,4.275,0,0,1,74.146,82.325ZM11.388,32.747A6.771,6.771,0,0,1,17.6,23.3h.057a8.433,8.433,0,0,1,8.367,8.423v1.023H11.388ZM35.644,96.58c-.038,0-.076-.006-.114-.006-3.927-.012-6.664-4.366-6.664-8.266V31.724a11.236,11.236,0,0,0-3.769-8.4l43.319.135c3.927.012,6.664,4.366,6.664,8.266V69.25A17.569,17.569,0,0,0,61,84.449H42.7a1.418,1.418,0,0,0-1.228,2.129c.16.277.3.486.416.654.293.433.4.6.4,2.584C42.293,92.079,39.294,96.486,35.644,96.58Zm9.486-6.764a13.583,13.583,0,0,0-.164-2.531h15.94a17.427,17.427,0,0,0,3.268,9.382l-22.4-.065a10.467,10.467,0,0,0,3.354-6.786ZM68.743,97.5a9.831,9.831,0,0,1,19.345,0,14.65,14.65,0,0,1-19.345,0ZM32.925,59.512a1.419,1.419,0,0,1,1.418-1.418H45.43a1.418,1.418,0,1,1,0,2.837H34.343a1.419,1.419,0,0,1-1.418-1.418Zm-.174,7.675a1.419,1.419,0,0,1,1.418-1.418H51.7a1.418,1.418,0,1,1,0,2.837H34.169A1.419,1.419,0,0,1,32.751,67.187ZM62.02,75.116H34.343a1.418,1.418,0,0,1,0-2.837H62.02a1.418,1.418,0,0,1,0,2.837Z",
    transform: "translate(1008.788 1700.77)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    transform: "translate(1047.794 1727.246)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.373,
    cy: 13.373,
    r: 13.373,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.373,
    cy: 13.373,
    r: 11.873,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\xA3",
    transform: "translate(1055.338 1744.675)",
    fill: "#008abb",
    fontSize: 14,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.031em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3")), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    transform: "translate(1069.054 1769.079)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.174,
    cy: 18.174,
    r: 18.174,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.174,
    cy: 18.174,
    r: 16.674,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_1",
    "data-name": "Grupo de m\\xE1scara 1",
    transform: "translate(1069.054 1769.079)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    transform: "translate(4.115 17.831)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.059,
    cy: 14.059,
    r: 14.059,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.059,
    cy: 14.059,
    r: 12.559,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    transform: "translate(1079.34 1775.937)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.887,
    cy: 7.887,
    r: 7.887,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.887,
    cy: 7.887,
    r: 6.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    transform: "translate(1069.054 1769.079)",
    fill: "none",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.174,
    cy: 18.174,
    r: 18.174,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.174,
    cy: 18.174,
    r: 16.674,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayroll);
export default __webpack_public_path__ + "static/media/icon_payroll.b9202b0c4f20331054583aa935f75a11.svg";
export { ForwardRef as ReactComponent };